import { NavLink } from "react-router-dom";

import type { CartItem } from "@src/api/marketplace/cart";
import { offerLink } from "@src/utils/offerLink";

type Props = {
  item: CartItem;
};

const SidebarCartItem = ({ item }: Props) => {
  const unitPrice = item.price.value / 1000;

  return (
    <div className="border-b border-gray-300 px-1 py-1">
      <NavLink
        to={`/marketplace/offers${offerLink(item.name, item.offerId)}`}
        className="flex items-center rounded p-1 hover:bg-gray-100"
      >
        <div className="flex flex-col">
          <img
            src={`${import.meta.env.VITE_MARKETPLACE_API_URL}/asset/${item.featuredImage}`}
            alt={item.name}
            className="h-32 w-32 rounded object-cover"
          />
          <span className="mt-1 text-center text-sm font-semibold text-gray-700">
            {unitPrice.toFixed(2)} {item.price.currencySymbol}
          </span>
        </div>
      </NavLink>

      <div className="mt-2 flex justify-center">
        <div className="rounded-full border border-[#1DA1F2] px-7 text-sm font-medium text-gray-700">
          {item.amount}
        </div>
      </div>
    </div>
  );
};

export default SidebarCartItem;
